import { GridResourceId } from '../reporting/grid-resource.model';

export enum GridLoadRequestKeys {
  resourceId = 'resourceId',
  loadOptions = 'loadOptions',
}

export type GridLoadOptions = Record<string, unknown>;

export interface GridLoadRequest {
  [GridLoadRequestKeys.resourceId]: GridResourceId;
  [GridLoadRequestKeys.loadOptions]: GridLoadOptions;
}

export interface GridLoadResponse<TItem extends Record<string, unknown> = Record<string, unknown>> {
  data: TItem[];
  totalCount?: number;
  summary?: unknown[];
  groupCount?: number;
}
